import React from "react";
import { Alert } from "@material-ui/lab";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../styles/styledTable";
import { StyledBreakWord } from "../../styles/styledBreakWord";

const BlockchainUrlList = ({ blockchainUrls, setOpen, submitData, setSubmitData }) => {
  const { t } = useTranslation("blockchainUrlPage");

  if (!blockchainUrls) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (blockchainUrls.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>;
  }

  return (

    <StyledScrollTable className="blockchain-url_scroll">
      <StyledTable
        width="992"
        size="16"
        className="blockchain-url-table"
      >
        <StyledTableHead
          className="blockchain-url__head"
          scroll="auto"
          col="5"
        >
          <div className="blockchain-url__col blockchain-url_col-fixed">
            {t("table.currency")}
          </div>
          <div className="blockchain-url__col">
            {t("table.paymentSystem")}
          </div>
          <div className="blockchain-url__col">
            {t("table.link")}
          </div>
          <div className="blockchain-url__col">
            {t("table.action")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {blockchainUrls && blockchainUrls.map((url, key) => (
            <StyledTableRow
              className="blockchain-url__row"
              key={key}
              scroll="auto"
              col="5"
            >
              <StyledCol
                data-title={t("table.currency")}
                className="blockchain-url__col blockchain-url_col-fixed"
              >
                {url.currency.asset}
              </StyledCol>
              <StyledCol
                data-title={t("table.paymentSystem")}
                className="blockchain-url__col"
              >
                {url.paymentSystem.name}
              </StyledCol>
              <StyledCol
                inline
                data-title={t("table.link")}
                className="blockchain-url__col"
              >
                <StyledBreakWord as="p">
                  {url.value}
                </StyledBreakWord>
              </StyledCol>
              <StyledCol
                inline
                data-title={t("table.action")}
                className="blockchain-url__col"
              >
                <div className="blockchain-url__actions">
                  <NavLink
                    className="table-action table-action_info"
                    to={"/blockchain-urls/" + url.id}
                  >
                    <span className="icon-light-edit" />
                    {t("table.edit")}
                  </NavLink>
                  <button
                    className="table-action table-action_info"
                    onClick={() => {
                      setSubmitData({
                        ...setSubmitData,
                        id: url.id
                      });
                      setOpen(true);
                    }}
                  >
                    <span className="icon-light-cancel" />
                    {t("table.delete")}
                  </button>
                </div>
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};
export default BlockchainUrlList;